<template>
  <b-container flex>
    <div style="padding-top: 20px; padding-bottom: 10px"><span
        style="font-weight: bold; font-size: large; padding-top: 20px; padding-bottom: 10px">CO2e Metric Tons Emissions</span>
    </div>
    <b-row style="padding-top: 5px" align-h="center">
      <b-col cols="2" style="padding-right: 2px;">Provider:</b-col>
      <b-col lg="10">
        <b-form-radio-group v-model="calculationType">
          <b-form-radio :style="getRadioStyle(co2CalcTypes)"
                        v-for="option in co2CalcTypes"
                        :key="option"
                        :value="option"
                        name="flavour-3a"
                        size="lg">
            {{ option }}
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row style="padding-top: 5px ">
      <b-col sm="9">Electricity CO2e:</b-col>
      <b-col sm="3">
        <b-form-input v-model="electricityEmissions" readonly min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">

      <b-col sm="9">Natural Gas CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="naturalGasEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">

      <b-col sm="9">Propane CO2e:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="propaneEmissions" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>
    <b-row style="padding-top:5px;">
      <b-col sm="9">Total CO2e/Case:</b-col>
      <b-col sm="3">
        <b-form-input readonly v-model="totalCO2PerCase" min="0" max="1000" step=".10"
                      type="number"></b-form-input>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import Bus from '@/eventBus';
import {roundColumnValueToOneDecimalPlace} from "@/MetricUtils";

export default {
  name: "Co2Metrics",
  props: {year: Number, groupId: String},
  data() {
    return {

      myGroupId: this.groupId,
      calculationTypeId: null,
      totalElectricity: 100000,
      totalNaturalGas: 100000,
      totalPropane: 100000,
      totalGasoline: 100000,
      totalDiesel: 100000,
      solar: 0,
      agMeter1: 0,
      agMeter2: 0,
      agMeter3: 0,
      totalTons: 0,
      tonnageCoefficient: 2204.6,
      calculationType: 'PG&E',
      co2CalcTypes: ['PG&E', 'MCE Light Green', 'MCE Deep Green'],
      vineyardAcreage: 0,

      //  All the variables from Per Case Metrics
      totalGridElectricityVal: 0,
      totalGridSolarVal: 0,
      myYear: this.year,
      equivalentCases: 0,
      totalGallonsOfWine: 0,
      wineryProcess: 0,
                officeWater: 0, // change this once the land water is done
                landWater: 0,
                landscapeWaterPerGalOfWine: 0,
                //totalWaterPerGalOfWine: 0,
                totalGridElectricityPerGalOfWine: 0,
                totalGridElectricityPerCase: 0,
                totalElectricityPerCase: 0,
                totalGridSolarPerCase: 0,
                insideWaterPerGalOfWine: 0
    }
  },
  watch: {
    year: function (newVal, oldVal) {
      console.log(`Year old val: ${oldVal}`)
      this.myYear = newVal;
    },
    groupId: function (newVal, oldVal) {
      console.log(`groupId old val: ${oldVal}`)
      this.myGroupId = newVal;
      this.loadCalculationType();
    },
    calculationType: function (newVal, oldVal) {
      console.log(`Calculation type updated from ${oldVal} to ${newVal}`)
      this.sendUpdate();
    }
  },
  created() {
    Bus.$on('vineyard-fertilizer-edited', this.fertilizerProductionUpdate);
    Bus.$on('vineyard-gas-edited', this.gasUsageUpdate);
    Bus.$on('yield-data', this.yieldDataUpdate);
    Bus.$on('vineyard-power-edited', this.powerUpdate);
    //Start Here, possibly delete all above
    Bus.$on('grid-edited', this.calcVariFromUpdate);
    Bus.$on('wine-production', this.wineProductionUpdate);

  },
  beforeDestroy() {
    Bus.$off('vineyard-fertilizer-edited', this.fertilizerProductionUpdate);
    Bus.$off('vineyard-gas-edited', this.gasUsageUpdate);
    Bus.$off('yield-data', this.yieldDataUpdate);
    Bus.$off('vineyard-power-edited', this.powerUpdate);
    //Start Here, possibly delete all above
    Bus.$off('grid-edited', this.calcVariFromUpdate);
    Bus.$off('wine-production', this.wineProductionUpdate);
  },
  mounted() {
    this.loadCalculationType();
  },
  computed:
      {
        electricityCoefficient: function () {
          let coefficient;
          switch (this.calculationType) {
            case "PG&E":
              coefficient = .252;
              break;
            case "MCE Light Green":
              coefficient = .127;
              break;
            case "MCE Deep Green":
              coefficient = 0;
              break;
            default:
              coefficient = 0;
          }
          return coefficient;
        },
        electricityEmissions: function () {
          console.log("electricity EmissionS");
          let electricity = (this.totalGridElectricityVal * this.electricityCoefficient) / this.tonnageCoefficient;
          return electricity.toFixed(1);
        },
        naturalGasEmissions: function () {
          let naturalGas = (this.totalNaturalGas * 11.7) / this.tonnageCoefficient;
          return naturalGas.toFixed(1);
        },
        propaneEmissions: function () {
          let propane = (this.totalPropane * 12.7) / this.tonnageCoefficient;
          return propane.toFixed(1);
        },
        gasolineEmissions: function () {
          let gasoline = (this.totalGasoline * 19.6) / this.tonnageCoefficient;
          return gasoline.toFixed(1);
        },
        dieselEmissions: function () {
          let diesel = (this.totalDiesel * 22.2) / this.tonnageCoefficient;
          return diesel.toFixed(1);
        },
        totalCO2PerCase: function () {
          if (this.equivalentCases === 0) {
            return 0;
          }
          let electricity = (this.totalGridElectricityVal * this.electricityCoefficient) / this.tonnageCoefficient;
          let naturalGas = (this.totalNaturalGas * 11.7) / this.tonnageCoefficient;
          let co2PerTon = (electricity + naturalGas) / this.equivalentCases;
          return co2PerTon.toFixed(1);
        },
        totalCO2e: function () {
          console.log("total co2e");
          if (this.equivalentCases === 0) {
            return 0;
          }
          let electricity = ((this.totalGridElectricityVal + this.totalGridSolarVal) * this.electricityCoefficient) / this.tonnageCoefficient;
          let naturalGas = (this.totalNaturalGas * 11.7) / this.tonnageCoefficient;
          let co2PerTotal = (electricity + naturalGas);
          this.sendUpdateTotalCo2Update(co2PerTotal);
          return co2PerTotal.toFixed(2);
        }

      },
  methods: {
    roundColumnValue: function (value) {
      return roundColumnValueToOneDecimalPlace(value);
    },
    sendUpdateTotalCo2Update: function (totalCo2) {
      let co2Data = {
        year: Number(this.myYear),
        totalCo2e: Number(totalCo2) || 0
      }
      console.log(`CO2Data: ${co2Data}`);
    },
    loadCalculationType: function () {
      console.log("Reloading Calculation Type");
      let self = this;
      this.$http.get(`metrics/calculation/type/${self.myGroupId}/${self.myYear}`)
          .then(result => {
            if (result.data && result.data !== "") {
              let vineyardCalculationType = result.data;
              self.calculationType = vineyardCalculationType.calculationType;
              self.calculationTypeId = vineyardCalculationType.id;
            }
          })
          .catch(err => {
            this.handleError(err);
            this.$nextTick(this.sendUpdate(this.year))
          });
    },
    sendUpdate: function () {
      this.uploadCalculationType();
    },
    uploadCalculationType: function () {
      let self = this;
      let calculationTypeUpload = {
        calculationType: self.calculationType,
        groupId: self.groupId,
        id: self.calculationTypeId,
        year: self.myYear
      };
      let calculationTypeJson = calculationTypeUpload;

      if (self.calculationTypeId === undefined || self.calculationTypeId === null) {
        this.postCalculationType(calculationTypeJson);
      } else {
        this.putCalculationType(calculationTypeJson);
      }
    },
    postCalculationType: function (calcType) {
      let self = this;
      this.$http.post('metrics/calculation/type', calcType
          , {
            headers: {
              'content-type': 'application/json'
            }
          }).then(response => {
        self.calculationTypeId = response.data.id;
        console.log(response);
      });
    },
    putCalculationType: function (calcType) {
      this.$http.put('metrics/calculation/type', calcType
          , {
            headers: {
              'content-type': 'application/json'
            }
          }).then(response => {
        console.log(response);
      });
    },
    getRadioStyle: function (optionsList) {
      if (!optionsList) {
        return "font-size: medium";
      }
      return 'font-size: medium; padding-bottom:5px;'
    },
    fertilizerProductionUpdate: function (wineProduction) {
      // No Op because we don't care about this.
      console.log(wineProduction);
    },
    gasUsageUpdate: function (gasUsage) {
      console.log("Gas Usage Below.")
      console.log(gasUsage);
      if (gasUsage.year === this.year) {
        this.totalNaturalGas = gasUsage.naturalGas;
        this.totalPropane = gasUsage.propane;
        this.totalGasoline = gasUsage.gasoline;
        this.totalDiesel = gasUsage.diesel;
        console.log(gasUsage);
      }

    },
    yieldDataUpdate: function (yieldData) {
      console.log("Yield Data Received");
      console.log(yieldData);
      if (yieldData.year === this.year) {
        this.totalTons = yieldData.totalTons;
        this.vineyardAcreage = yieldData.vineyardAcreage;
      }
    },
    powerUpdate: function (powerData) {
      console.log("Power Data Received in Co2Metrics");
      console.log(powerData);
      if (powerData.year === this.year) {
        this.solar = powerData.solar;
        this.agMeter1 = powerData.agMeter1;
        this.agMeter2 = powerData.agMeter2;
        this.agMeter3 = powerData.agMeter3;
      }
    },
    doToast: function (message) {
      this.$toasted.show(message,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: 'fa-times-circle',
              after: false,
            }
          })
          .goAway(5000);
    },
    calcVariFromUpdate: function (total) {
      if (Number(total.year) === this.myYear) {
        if (total.gridType === "solarProductivity") {
          this.totalGridSolarVal = total.total;
          this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
          this.totalGridSolarPerCase = this.equivalentCases !== 0 ? (this.totalGridSolarVal / this.equivalentCases).toFixed(1) : 0;
        } else if (total.gridType === "electricMeter" || total.gridType === "electricMeter2" ||
            total.gridType === "electricMeter3") {
          this.totalGridElectricityVal = total.total;
          this.totalGridElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal) / this.equivalentCases).toFixed(1) : 0;
          this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                } else if (total.gridType === "waterGrid") {
                  this.officeWater = total.tastingOffices;
                  this.landWater = total.landscaping;
                  this.wineryProcess = total.wineryProcess;
                  this.totalGallonsOfWine = (this.landWater + this.wineryProcess + this.officeWater);
                  //this.totalWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater + this.wineryProcess + this.officeWater) / this.totalGallonsOfWine : 0;
                  this.landscapeWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater / this.totalGallonsOfWine).toFixed(1) : 0;
                } else if (total.gridType === "powerEmission") {
                  this.totalGridElectricityVal = total.totalGrid;
                  this.totalGridSolarVal = total.totalSolar;
                  this.totalGridElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalGridSolarPerCase = this.equivalentCases !== 0 ? (this.totalGridSolarVal / this.equivalentCases).toFixed(1) : 0;
                } else if (total.gridType === "gasEmission") {
                  this.totalNaturalGas = total.totalGas;
                  this.totalPropane = total.totalPropane;
                  this.totalGridElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalElectricityPerCase = this.equivalentCases !== 0 ? ((this.totalGridElectricityVal + this.totalGridSolarVal) / this.equivalentCases).toFixed(1) : 0;
                  this.totalGridSolarPerCase = this.equivalentCases !== 0 ? (this.totalGridSolarVal / this.equivalentCases).toFixed(1) : 0;
                }
              }
            },
    wineProductionUpdate: function (wineProduction) {
      if (Number(wineProduction.year) === this.myYear) {
        if (wineProduction.type === "totalWine") {
          this.totalGallonsOfWine = wineProduction.total;
          this.landscapeWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? (this.landWater / this.totalGallonsOfWine).toFixed(1) : 0;
          this.insideWaterPerGalOfWine = this.totalGallonsOfWine !== 0 ? ((this.wineryProcess + this.officeWater) / this.totalGallonsOfWine).toFixed(1) : 0;
        } else {
          this.equivalentCases = wineProduction.total;
        }
      }

            }
  }
}
</script>

<style scoped>

</style>
